var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sketch-content flex"},[_c('div',{staticClass:"page-content"},[_c('SketchBreadcrumb',{attrs:{"pageName":"Proiectul în MySMIS"}}),_c('div',{staticClass:"padding-box"},[_c('MySmisContent',{attrs:{"allData":_vm.allData}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }